import { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { Logo } from '../components/Logo';
import { signIn } from '../lib/auth';

export function Login() {
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await signIn(email.trim(), password);
      nav('/choose', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sign-in failed.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main style={{ maxWidth: 380, margin: '0 auto', padding: '96px 24px' }}>
      <div style={{ color: 'var(--primary)', marginBottom: 28, transform: 'scale(1.6)', transformOrigin: 'left' }}>
        <Logo />
      </div>
      <h1 style={{ fontSize: 24, fontWeight: 800, letterSpacing: '-0.018em', marginBottom: 4 }}>Sign in</h1>
      <p style={{ color: 'var(--ink-2)', fontSize: 14, marginBottom: 24 }}>Restoplus Admin</p>
      <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div className="field">
          <label htmlFor="email">Email</label>
          <input id="email" className="input" type="email" autoComplete="username" required
            value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className="field">
          <label htmlFor="password">Password</label>
          <input id="password" className="input" type="password" autoComplete="current-password" required
            value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        {error && <div className="err" role="alert">{error}</div>}
        <button className="btn btn-primary" disabled={busy} style={{ justifyContent: 'center' }}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
      <p style={{ fontSize: 13, marginTop: 20 }}>
        <Link to="/forgot-password" style={{ color: 'var(--primary)', fontWeight: 700 }}>Forgot password?</Link>
      </p>
    </main>
  );
}
